import React, {useState, useEffect} from 'react';
import './dropdown.css';

export default function Dropdown(props) {
  const {label, labelStyle, containerStyle, options, onMenuClick, id} = props;
  const [showMenu, toggleMenu] = useState(false);

  useEffect(() => {
    window.addEventListener('click', (e) => {
      if(e.target !== id) {
        toggleMenu(false);
      }
    });
  }, [id]);

  const handleContainerClick = (e) => {
    e.stopPropagation();
    toggleMenu(true);
  };

  const handleMenuClick = (item) => (e) => {
    e.stopPropagation();
    onMenuClick(item);
    toggleMenu(false);
  };

  return (
    <div className="dropdown-container" style={containerStyle} tabIndex="0" onClick={handleContainerClick} id={id}>
      <div className="dropdown-label-container">
        <span style={labelStyle}>{label}</span>
      </div>
      {showMenu && (
        <div className="dropdown-menu-container">
          {options.map((op) => (
            <div className="dropdown-menu-item" role="button" tabIndex={0} key={op[0]} onClick={handleMenuClick(op[1])}>
              {op[1]}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
